import { render, staticRenderFns } from "./LKRegMehList.vue?vue&type=template&id=1672f0d1&"
import script from "./LKRegMehList.vue?vue&type=script&lang=js&"
export * from "./LKRegMehList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports